import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": ".85",
  d: "M10.229 26.266s16.739-3.168 18.674-3.168C32 23.486 32 28.518 32 28.518l-17.033 3.484c0-4.259-3.097-5.807-4.118-5.807-1.566 0-2.85 1.185-2.85 3.097 0 1.53 1.02 2.71 2.273 2.71 1.003 0 1.983-.652 1.983-1.876 0-.979-.856-1.731-1.659-1.731l2.823-.652"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": ".85",
  d: "M16.516 26.97c.775.386 1.069 1.563 1.161 1.935l12-2.323s0-.774-.774-1.548M10.559 31.984l4.33-1.115M8.387 24.647S8 24.115 8 23.098l3.87-3.87M21.936 7.999c9.677 0 9.677 10.84 9.677 10.84H29.29l-4.257 1.16-1.549 1.549c-4.258.774-9.29.774-11.614-1.161v-2.323s0-4.645 3.097-6.58"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": ".85",
  d: "M28.903 11.099c-1.648-.927-3.752-1.1-5.667-.977a6.77 6.77 0 0 0-6.156 5.24v0a.775.775 0 0 1-.941.578l-1.606-.402a.774.774 0 0 1-.57-.913l.23-1.07c.616-2.875 2.967-5.1 5.888-5.445a16 16 0 0 1 1.855-.106"
}, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("path", {
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": ".85",
  d: "M27.355 12.647s-7.742-.387-8.516 6.967M30.452 18.838s.386 1.306 0 2.322"
}, null, -1)
const _hoisted_6 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4,
  _hoisted_5
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_6]))
}
export default { render: render }